export default {"src":"/_next/static/media/TAG3.d1436aa1.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};